import { getUser } from '../../util/getUser';
import { isWorldShalichRole, myPageRoute, WORLD_SHALICH_TAGS } from '../../constants';
import LandingPage from './LandingPage';
import { FeedContainer } from '../../pages/dashboard/Feed';
import CrmDashboard from '../../pages/dashboard/crm/CrmDashboard';
import { useEffect, useMemo } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { hasCrmAccess } from '../../util/Permission';

const Intro = () => {
  const user = getUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate('/login');
    }
  }, [user, navigate]);

  const isWorldShaliach =
    isWorldShalichRole(user?.role) || WORLD_SHALICH_TAGS.some(tag => user?.tags?.includes(tag));

  const targetPage = useMemo(() => {
    if (hasCrmAccess(user?.tags || [])) {
      return <CrmDashboard />;
    }
    return <FeedContainer isPage={true} />;
  }, [user]);

  if (isWorldShaliach) {
    return <Navigate to={myPageRoute} replace />;
  }

  if (!user) {
    return null;
  }

  return <LandingPage targetPage={targetPage} useOnReadyCallback={true} showIntro={true} />;
};

export default Intro;
